export const groupIcons = {
  Sumarios: "pi-file",
  Expedientes: "pi-folder",
  "UFI delitos": "pi-desktop",
  Preliminares: "pi-file-excel",
  Depósito: "pi-bars",
};

export const sidebarLinks = [
  {
    path: "/",
    pathName: "escritorio",
    titulo: "Escritorio",
    icon: "pi-chart-bar",
    roles: [],
    excludesRoles: ["Calabocero"],
    type: "button",
    grupo: "TOP",
  },
  {
    path: "/actuaciones/list",
    pathName: "actuaciones",
    titulo: "Actuaciones",
    icon: "pi-list",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
      "UsuarioDependencia",
      "Control de Gestion",
      "Dirección de Información para el Delito D-2",
      "Dpto. Asuntos Judiciales D-5",
      "Dpto. Planeamiento",
      "Juez",
      "Ayudante de Juez",
      "Dpto.Criminalistica",
      "Lab. Informatico Forense",
      "Administrativo",
      "Ayudante Fiscal",
      "Fiscal",
      "Fiscal General",
      "Policia Investigador",
      "Supervisor",
      "UsuarioDepartamental",
      "Notificante - Departamental",
    ],
    type: "button",
    grupo: "TOP",
  },
  {
    path: "/actuaciones/new/sumario-denuncia/initial",
    pathName: "sumario-denuncia",
    titulo: "Sumario Denuncia",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "Sumarios",
    props: {
      formType: "denuncia",
      actuacionType: "sumario-denuncia",
      pageTitle: "PREVENCIONAL DENUNCIA",
    },
  },
  {
    path: "/actuaciones/new/sumario-oficio/initial",
    pathName: "sumario-oficio",
    titulo: "Sumario Oficio",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "Sumarios",
    props: {
      formType: "oficio",
      actuacionType: "sumario-oficio",
      pageTitle: "PREVENCIONAL OFICIO",
    },
  },
  {
    path: "/actuaciones/new/expediente-denuncia/initial",
    pathName: "expediente-denuncia",
    titulo: "Expediente Denuncia",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "Expedientes",
    props: {
      formType: "contravencional-denuncia",
      actuacionType: "expediente-denuncia",
      pageTitle: "CONTRAVENCIONAL DENUNCIA",
    },
  },
  {
    path: "/actuaciones/new/expediente-oficio/initial",
    pathName: "expediente-oficio",
    titulo: "Expediente Oficio",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "Expedientes",
    props: {
      formType: "contravencional-oficio",
      actuacionType: "expediente-oficio",
      pageTitle: "CONTRAVENCIONAL OFICIO",
    },
  },
  {
    path: "/actuaciones/new/ufi-flagrancia/initial",
    pathName: "ufi-flagrancia",
    titulo: "Flagrancia",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "UFI delitos",
    props: {
      formType: "ufi-flagrancia",
      actuacionType: "ufi-flagrancia",
      pageTitle: "UFI - FLAGRANCIA",
    },
  },
  {
    path: "/actuaciones/new/ufi-propiedad-denuncia/initial",
    pathName: "ufi-propiedad-denuncia",
    titulo: "Contra la Propiedad por Denuncia",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "UFI delitos",
    props: { formType: "ufi-anivi", actuacionType: "ufi-anivi", pageTitle: "UFI - ANIVI" },
  },
  {
    path: "/actuaciones/new/ufi-propiedad-oficio/initial",
    pathName: "ufi-propiedad-oficio",
    titulo: "Contra la Propiedad por Oficio",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "UFI delitos",
    props: { formType: "ufi-anivi", actuacionType: "ufi-anivi", pageTitle: "UFI - ANIVI" },
  },
  {
    path: "/actuaciones/new/ufi-informatica-denuncia/initial",
    pathName: "ufi-informatica-denuncia",
    titulo: "Informáticos y Estafas por Denuncia",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "UFI delitos",
    props: { formType: "ufi-anivi", actuacionType: "ufi-anivi", pageTitle: "UFI - ANIVI" },
  },
  {
    path: "/actuaciones/new/ufi-informatica-oficio/initial",
    pathName: "ufi-informatica-oficio",
    titulo: "Informáticos y Estafas por Oficio",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "UFI delitos",
    props: { formType: "ufi-anivi", actuacionType: "ufi-anivi", pageTitle: "UFI - ANIVI" },
  },
  {
    path: "/actuaciones/new/ufi-cavig/initial",
    pathName: "ufi-cavig",
    titulo: "Cavig",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "UFI delitos",
    props: { formType: "ufi-cavig", actuacionType: "ufi-cavig", pageTitle: "UFI - CAVIG" },
  },
  {
    path: "/actuaciones/new/ufi-anivi/initial",
    pathName: "ufi-anivi",
    titulo: "Anivi",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "UFI delitos",
    props: { formType: "ufi-anivi", actuacionType: "ufi-anivi", pageTitle: "UFI - ANIVI" },
  },
  {
    path: "/actuaciones/ufi-genericos/menu",
    pathName: "ufi-genericos",
    titulo: "Genéricos",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "submenu", // Cambiamos el type a 'submenu'
    grupo: "UFI delitos",
    props: { formType: "ufi-genericos", pageTitle: "UFI - GENÉRICOS" },
    items: [
      // Agregamos la propiedad 'items' que contendrá los submenús
      {
        path: "/actuaciones/new/ufi-generica-denuncia/initial",
        pathName: "ufi-generica-denuncia",
        titulo: "Genéricos por Denuncia",
        roles: [
          "User Tester",
          "Super User",
          "Jefe de Dependencia",
          "Oficial Sumariante",
          "Jefe de Sumario",
        ],
        type: "link",
        props: { formType: "ufi-anivi", actuacionType: "ufi-anivi", pageTitle: "UFI - ANIVI" },
      },
      {
        path: "/actuaciones/new/ufi-generica-oficio/initial",
        pathName: "ufi-generica-oficio",
        titulo: "Genéricos por Oficio",
        roles: [
          "User Tester",
          "Super User",
          "Jefe de Dependencia",
          "Oficial Sumariante",
          "Jefe de Sumario",
        ],
        type: "link",
        props: {
          formType: "ufi-establecer-paradero",
          actuacionType: "ufi-establecer-paradero",
          pageTitle: "UFI - ESTABLECER PARADERO",
        },
      },
      {
        path: "/actuaciones/new/ufi-establecer-paradero/initial",
        pathName: "ufi-establecer-paradero",
        titulo: "Establecer Paradero",
        roles: [
          "User Tester",
          "Super User",
          "Jefe de Dependencia",
          "Oficial Sumariante",
          "Jefe de Sumario",
        ],
        type: "link",
        props: { formType: "ufi-anivi", actuacionType: "ufi-anivi", pageTitle: "UFI - ANIVI" },
      },
    ],
  },
  {
    path: "/actuaciones/ufi-delitos-especiales/menu",
    pathName: "ufi-delitos-especiales",
    titulo: "Especiales",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "submenu",
    grupo: "UFI delitos",
    props: { formType: "ufi-delitos-especiales", pageTitle: "UFI - DELITOS ESPECIALES" },
    items: [
      {
        path: "/actuaciones/new/ufi-emergencias-medicas/initial",
        pathName: "especiales-médicas",
        titulo: "Emergencias Medicas",
        roles: [
          "User Tester",
          "Super User",
          "Jefe de Dependencia",
          "Oficial Sumariante",
          "Jefe de Sumario",
        ],
        type: "link",
        grupo: "Especiales",
        props: { formType: "especiales-médicas", pageTitle: "EMERGENCIAS MÉDICAS" },
      },
      {
        path: "/actuaciones/new/ufi-siniestro-vial/initial",
        pathName: "especiales-vial",
        titulo: "Siniestro Vial",
        roles: [
          "User Tester",
          "Super User",
          "Jefe de Dependencia",
          "Oficial Sumariante",
          "Jefe de Sumario",
        ],
        type: "link",
        grupo: "Especiales",
        props: { formType: "especiales-vial", pageTitle: "SINIESTRO VIAL" },
      },
      {
        path: "/actuaciones/new/ufi-suicidio/initial",
        pathName: "especiales-ahorcamiento-suicidio",
        titulo: "Ahorcamiento o Suicidio",
        roles: [
          "User Tester",
          "Super User",
          "Jefe de Dependencia",
          "Oficial Sumariante",
          "Jefe de Sumario",
        ],
        type: "link",
        grupo: "Especiales",
        props: {
          formType: "especiales-ahorcamiento-suicidio",
          pageTitle: "AHORCAMIENTO O SUICIDIO",
        },
      },
      {
        path: "/actuaciones/new/ufi-incendio-vivienda/initial",
        pathName: "especiales-incendio-vivienda",
        titulo: "Incendio en Vivienda",
        roles: [
          "User Tester",
          "Super User",
          "Jefe de Dependencia",
          "Oficial Sumariante",
          "Jefe de Sumario",
        ],
        type: "link",
        grupo: "Especiales",
        props: { formType: "especiales-incendio-vivienda", pageTitle: "INCENDIO EN VIVIENDA" },
      },
      {
        path: "/actuaciones/new/ufi-intoxicacion/initial",
        pathName: "especiales-intoxicación",
        titulo: "Intoxicación",
        roles: [
          "User Tester",
          "Super User",
          "Jefe de Dependencia",
          "Oficial Sumariante",
          "Jefe de Sumario",
        ],
        type: "link",
        grupo: "DELITOS-ESPECIALES",
        props: { formType: "especiales-intoxicación", pageTitle: "INTOXICACIÓN" },
      },
      {
        path: "/actuaciones/new/ufi-otros/initial",
        pathName: "ufi-otros",
        titulo: "Otros",
        roles: [
          "User Tester",
          "Super User",
          "Jefe de Dependencia",
          "Oficial Sumariante",
          "Jefe de Sumario",
        ],
        type: "link",
        grupo: "DELITOS-ESPECIALES",
        props: { formType: "ufi-otros", pageTitle: "UFI - OTROS" },
      },
    ],
  },
  // {
  //   path:'/actuaciones/preliminares/menu',
  //   pathName:'preliminares',
  //   titulo:'Preliminares',
  //   icon: 'pi-microsoft',
  //   roles:['User Tester','Super User','Jefe de Dependencia','Oficial Sumariante','Jefe de Sumario'],
  //   type:'link',
  //   grupo:'Preliminares',
  //   props: { formType: "actuaciones-preliminares" ,  pageTitle: "ACTUACIONES PRELIMINARES"},
  // },
  {
    path: "/actuaciones/new/preliminares-incendio-vivienda/initial",
    pathName: "preliminares-incendio-vivienda",
    titulo: "Incendio en vivienda",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "Preliminares",
    props: {
      formType: "preliminar-incendio-vivienda",
      actuacionType: "preliminares-incendio-vivienda",
    },
  },
  {
    path: "/actuaciones/new/preliminares-establecer-procedencia/initial",
    pathName: "preliminares-establecer-procedencia",
    titulo: "Establecer procedencia",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "Preliminares",
    props: {
      formType: "preliminar-establecer-procedencias",
      actuacionType: "preliminares-establecer-procedencia",
    },
  },
  {
    path: "/actuaciones/new/preliminares-fuga-menor/initial",
    pathName: "preliminares-fuga-menor",
    titulo: "Fuga de menor",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "Preliminares",
    props: { formType: "preliminar-fuga-menor", actuacionType: "preliminares-fuga-menor" },
  },
  {
    path: "/actuaciones/new/preliminares-siniestro-vial/initial",
    pathName: "preliminares-siniestro-vial",
    titulo: "Siniestro vial",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "Preliminares",
    props: { formType: "preliminar-siniestro-vial", actuacionType: "preliminares-siniestro-vial" },
  },
  {
    path: "/actuaciones/new/preliminares-caida-casual/initial",
    pathName: "preliminares-caida-casual",
    titulo: "Caída casual",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "Preliminares",
    props: { formType: "preliminar-caida-casual", actuacionType: "preliminares-caida-casual" },
  },
  {
    path: "/actuaciones/new/preliminares-incendio-automotor/initial",
    pathName: "preliminares-incendio-automotor",
    titulo: "Incendio de automotor",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "Preliminares",
    props: {
      formType: "preliminar-incendio-automotor",
      actuacionType: "preliminares-incendio-automotor",
    },
  },
  {
    path: "/actuaciones/new/preliminares-suicidio/initial",
    pathName: "preliminares-suicidio",
    titulo: "Tentativa de suicidio",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "Preliminares",
    props: { formType: "preliminar-tentativa-suicidio", actuacionType: "preliminares-suicidio" },
  },
  {
    path: "/actuaciones/new/preliminares-otros/initial",
    pathName: "preliminares-otros",
    titulo: "Otros",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "Preliminares",
    props: { formType: "preliminar-otros", actuacionType: "preliminares-otros" },
  },
  {
    path: "/deposito/efectos",
    pathName: "deposito-efectos",
    titulo: "Efectos",
    roles: [
      "User Tester",
      "Super User",
      "Deposito Judicial",
      "Jefe de Dependencia",
      "UsuarioDepartamental",
    ],
    type: "link",
    grupo: "Depósito",
  },
  {
    path: "/deposito/solicitudes",
    pathName: "solicitudesView",
    titulo: "Solicitudes",
    roles: [
      "User Tester",
      "Super User",
      "Deposito Judicial",
      "Jefe de Dependencia",
      "UsuarioDepartamental",
    ],
    type: "link",
    grupo: "Depósito",
  },
  {
    path: "/parametros/list",
    pathName: "parametros",
    titulo: "Parametrización",
    icon: "pi-sliders-v",
    roles: ["User Tester", "Super User"],
    type: "link",
    grupo: "BOTTOM",
  },
  {
    path: "/location",
    pathName: "localizacion",
    titulo: "Localización",
    icon: "pi-map-marker",
    roles: ["Jefe de Dependencia", "Jefe de Sumario", "Oficial Sumariante", "Super User"],
    type: "link",
    grupo: "BOTTOM",
  },
  {
    path: "/calabozo",
    pathName: "calabozo",
    titulo: "Calabocero",
    icon: "pi-bell",
    roles: ["Calabocero", "Super User"],
    type: "button",
    grupo: "BOTTOM",
  },
  {
    path: "/sifcop",
    pathName: "sifcop",
    titulo: "SIFCOP",
    icon: "pi-id-card",
    roles: ["Super User"],
    devOnly: true,
    type: "button",
    grupo: "BOTTOM",
  },
  {
    path: "/bibliotecaVirtual",
    pathName: "bibliotecaVirtual",
    titulo: "Biblioteca Virtual",
    icon: "pi-search",
    roles: [
      "Super User",
      "UsuarioDepartamental",
      "Jefe de Dependencia",
      "Jefe de Sumario",
      "Oficial Sumariante",
    ],
    type: "button",
    grupo: "BOTTOM",
  },
  {
    path: "/editar-contrasena",
    pathName: "cambiar-contraseña",
    titulo: "Cambiar Contraseña",
    icon: "pi-lock",
    roles: [],
    type: "link",
    grupo: "BOTTOM",
  },
  {
    path: "/logout",
    pathName: "cerrar-Sesión",
    titulo: "Cerrar Sesión",
    icon: "pi-sign-out",
    roles: [],
    type: "link",
    grupo: "BOTTOM",
    action: "logout",
  },
  {
    path: "/notificaciones",
    pathName: "notificaciones",
    titulo: "Notificaciones",
    icon: "pi-bell",
    roles: ["Notificante", "Notificante - Departamental"],
    type: "button",
    grupo: "TOP",
  },
  {
    path: "/",
    pathName: "departamentales",
    titulo: "Departamentales",
    icon: "pi-file",
    roles: ["Notificante"],
    type: "button",
    grupo: "TOP",
  },
];
